import { useCookies } from 'react-cookie';
import { PROFILE } from '../constants/cookies';

const expires = new Date();
expires.setTime(expires.getTime() + 1000 * 60 * 60 * 24 * 7);

const useProfile = () => {
  const [cookies, setCookie, removeCookie] = useCookies([PROFILE]);

  const profile = cookies[PROFILE] || {};

  const setProfile = val => setCookie(PROFILE, { ...val }, { expires });

  const clearProfile = () => removeCookie(PROFILE);

  return { profile, setProfile, clearProfile };
};

export default useProfile;
